import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { hasMobileUserAgent } from '@carvana/stc-utilities';
import { CarvanaTheme } from '@carvana/theme';
import classnames from 'classnames';
import { useEffect } from 'react';
import styled from 'styled-components';

const BasicFooter = styled.div<FooterProps>`
  background-color: ${({ theme }) => theme.carvana.blue.dark};
  height: 610px;
`;

const Container = styled.div`
  background: #e4ecf0;
  width: 100%;
  &.nativeMobile {
    height: max-content;
  }
`;

const Inner = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1800px;
`;

type FooterProps = {
  theme?: typeof CarvanaTheme;
};

type FooterComponentProps = {
    environment?: string;
    withoutProvider: boolean;
};

const Footer = ({ theme = CarvanaTheme }: FooterProps) => {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'FooterModule',
          [
            {
              component: 'default',
              browser: true,
              default: {
                file: 'index.js',
                manifest: `${
                  process.env.CARVANA_APP_CDN_URL
                }/footer/module/assets-manifest.json?v=${Date.now()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);

  const nativeMobile = typeof window === 'object' ? hasMobileUserAgent(window.navigator) : false;

  return (
    <Container className={classnames({ nativeMobile })}>
      <Inner>
        <MfeReactComponent
          component="default"
          module="FooterModule"
          loading={<BasicFooter theme={theme} />}
        >
          {// eslint-disable-next-line react/no-unused-prop-types
          ({ Component }: { Component: React.ComponentType<FooterComponentProps> }) => (
            
            <Component environment={process.env.CARVANA_APP_ENVIRONMENT} withoutProvider />
          )}
        </MfeReactComponent>
      </Inner>
    </Container>
  );
};

export default Footer;
